import headers from './headers'

export default function(fetch) {
  return function() {
    return fetch(`${process.env.REACT_APP_API_URL}/orders/${localStorage.getItem('order_id')}/images`, {
      headers: headers(),
    })
      .then(res => res.json())
      .then(res =>
        res.map(original => ({
          src: original.content_url,
          filter: original.filter,
        }))
      )
      .then(res => res.reverse())
  }
}



// WEBPACK FOOTER //
// ./src/repositories/getPhotos.js